import React, { useState } from "react";
import "../css-dashboard/Dashboard.css";
import SidebarClient from "../../components/sidebar-dashboard/SidebarClient";
import ClientTripsConcludedNegotiations from "../../components/client-trips-negotiations/ClientTripsConcludedNegotiations";
import UseClientTripsNegotiations from "../../hooks/UseTripsNegotiations/UseClientTripsNegotiations";
import UseModalReceiverData from "../../hooks/UseModalReceiverData/UseModalReceiverData";
import ModalReceiverData from "../../components/modal-receiver-data/ModalReceiverData";

const TripsConcludedClient = ({ menuOpen, setMenuOpen }) => {
  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseClientTripsNegotiations();

  const {
    isOpenReceiverData,
    showSuccessScreenReceiverData,
    openModalReceiverData,
    closeModalReceiverData,
    selectedNegotiationReceiverData,
    formDataReceiverData,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingReceiverData,
    errorReceiverData,
    successReceiverData,
    errorsReceiverData,
  } = UseModalReceiverData(() => {
    refetchTripsNegotiations();
  });

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarClient menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Cliente</h1>
            <p className="breadcrumb">
              <a href="/dashboard-client">Início</a> / Encomendas Enviadas
            </p>
          </div>

          <ClientTripsConcludedNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverModal={openModalReceiverData}
          />
        </main>
      </div>

      <ModalReceiverData
        isOpenReceiverData={isOpenReceiverData}
        showSuccessScreenReceiverData={showSuccessScreenReceiverData}
        closeModalReceiverData={closeModalReceiverData}
        formDataReceiverData={formDataReceiverData}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingReceiverData={loadingReceiverData}
        errorReceiverData={errorReceiverData}
        errorsReceiverData={errorsReceiverData}
        successReceiverData={successReceiverData}
        selectedNegotiationReceiverData={selectedNegotiationReceiverData}
      />
    </>
  );
};

export default TripsConcludedClient;
